
import {TokenCredentials} from '../login/tokencredentials';

export class LocationSearch {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    name : string;
    descr : string;
    priority: number;
    task : string;

    matches : LocationSearchMatch[];
    filters : LocationSearchFilter[];

    created : Date;
    updated : Date;
}

export class LocationSearchMatch {
    id : number;

    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}

export class LocationSearchFilter {
    id : number;
    
    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-search.ts